import icsApi from '../../apis/ics.api';
export default {
  state: {
    hasRedPacket: false,
    seriesDownPrice: 0,
  },
  mutations: {
    setAractivityState(state, aractivityState) {
      state.seriesDownPrice = aractivityState.seriesDownPrice;
      state.hasRedPacket = aractivityState.hasRedPacket;
    },
  },
  getters: {
    seriesDownPrice: (state) => state.seriesDownPrice,
    hasRedPacket: (state) => state.hasRedPacket,
  },
  actions: {
    getAractivityState: function ({ commit }, { seriesId, dealerId }) {
      if (seriesId > 0 && dealerId > 0) {
        icsApi.getAractivityState(seriesId, dealerId).then((res) => {
          if (res) {
            commit('setAractivityState', res);
          }
        });
      }
    },
  },
  namespaced: true,
};
